import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { IconButton, CircularProgress, Tooltip } from '@mui/material'
import { AddAPhoto, Delete } from '@mui/icons-material'

import {
  uploadImage,
  createUserImageFormData
} from '../../utils/upload'

import {
  container,
  hiddenInput
} from './styles/ImageUploadFile.style'

class ImageUploadFile extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isUploading: false
    }
    this.fileInput = React.createRef()
  }

  static propTypes = {
    onUploadSuccess: PropTypes.func.isRequired,
    onUploadFailure: PropTypes.func,
    onRemove: PropTypes.func.isRequired,
    hasPhoto: PropTypes.bool,
    translation: PropTypes.func
  }

  static defaultProps = {
    onUploadFailure: () => undefined
  }

  render () {
    return (
      <div className={container}>
        <input
          onChange={this.processImage}
          className={hiddenInput}
          accept='.jpeg,.jpg,.png'
          type='file'
          ref={this.fileInput}
        />

        {!this.state.isUploading
          ? (
            <>
              <Tooltip
                title={this.props.translation('editUserForm')['updateProfileImage']}
                disableFocusListener
              >
                <IconButton
                  onClick={(e) => this.fileInput.current.click()}
                  color='inherit'
                >
                  <AddAPhoto />
                </IconButton>
              </Tooltip>
              {this.props.hasPhoto && (
                <Tooltip
                  title={this.props.translation('editUserForm')['removeProfileImage']}
                  disableFocusListener
                >
                  <IconButton
                    color='inherit'
                    onClick={this.removeImage}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )
          : <CircularProgress size={36} />
        }
      </div>
    )
  }

  setUploadingStatus = (isUploading = true, cb = () => null) => {
    this.setState({
      isUploading
    }, cb)
  }

  processImage = (e) => {
    try {
      const formData = createUserImageFormData(e)
      uploadImage(formData)
        .then((res) => this.setUploadingStatus(false, () => this.props.onUploadSuccess(res)))
        .catch(() => this.setUploadingStatus(false, () => this.props.onUploadFailure(this.props.translation('editUserForm')['uploadImageError'])))
      this.setUploadingStatus()
    } catch (error) {
      this.props.onUploadFailure(this.props.translation('editUserForm')['uploadImageSizeError'])
    }
  }

  removeImage = () => {
    this.setUploadingStatus()
    this.props.onRemove({
      url: null,
      cb: () => this.setUploadingStatus(false)
    })
  }
}

export default ImageUploadFile
